import React, { useContext } from 'react'
import cross from '../assets/cross1.png'
import Fonctions from './Fonctions'
import CantiquesList  from '../cantiques/CantiquesList'
import FooterSidebard from './FooterSidebard'
import { CantiqueContextAPI } from '../Context/CantiqueContext'
import { X } from 'lucide-react'
import ThemeToggle from '../components/ThemeToggle'

const Sidebard = () => {
  const { sidebarOpen, setSidebarOpen } = useContext(CantiqueContextAPI);

  return (
    <>
      {/* overlay for mobile when sidebar is open */}
      <div
        className={`sidebard__overlay ${sidebarOpen ? 'visible' : ''}`}
        onClick={() => setSidebarOpen(false)}
        aria-hidden={!sidebarOpen}
      />

      <div className={`sidebard ${sidebarOpen ? 'sidebard--open' : ''}`}>
         <div className="sidebard__container">
             <div className="sidebard__header">
                <div className="sidebard__header__logo">
                    <img src={cross} alt="" className="sidebard__header__logo__img" />
                </div>
                <div className="sidebard__header__texts">
                   <h2 className="sidebard__header__texts__title">
                    Atmosphere
                   </h2>
                   <div className="sidebard__header__texts__content">
                     Hymnes & Louanges
                   </div>
                </div>
               <ThemeToggle className="sidebard__header__theme" />
               {/* close button visible on mobile */}
               <button
                 className="sidebard__header__close"
                 aria-label="Fermer le menu"
                 onClick={() => setSidebarOpen(false)}
               >
                 <X size={18} />
               </button>
             </div>
             {/*  Vient le filtre au mileu  */}
              <Fonctions />
             {/* Fin du Filtre au milieu */}
             
             {/* DEBUT DU CANTIQUES */}
               <CantiquesList />
             {/* Fin du CANTIQUES */}
             <FooterSidebard />
         </div>
      </div>
    </>
  )
}

export default Sidebard